// extracted by mini-css-extract-plugin
module.exports = {"root":"InputColor_root__30rdd","inputColor":"InputColor_inputColor__2d6Q5","label":"InputColor_label__3vpbb"};